import { sentenceCase } from '@iheartjane/utils';
import words from 'lodash-es/words';

type Validations = Record<string, string[]>;

export const validationsToErrors = <T extends Validations>(
  validations: T
): { [P in keyof T]: string } => {
  const errorObject: any = {};
  for (const [key, value] of Object.entries(validations)) {
    errorObject[key] = sentenceCase(
      `${words(key).join(' ')} ${value.join(', ')}`
    );
  }

  return errorObject;
};

/**
 * Flattens the API's `{ field: ['is invalid'] }` validations into display ready
 * sentences.
 *
 * Server errors are rendered from component state rather than applied with
 * react-hook-form's `setError`, because `Form.SubmitButton` subscribes to
 * `formState.isValid` and the revalidation that subscription triggers after
 * submit discards externally applied errors.
 */
export const validationsToMessages = (
  validations: Validations = {}
): string[] => Object.values(validationsToErrors(validations));
